import { TaCard } from '@components/shared/TaCard/TaCard';
import { PromotionCard } from '@features/dashboard/specialistDashboard/PromotionCard/PromotionCard';
import { useWindowSize } from '@hooks/useWindowSize';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function Analytics({ specialist }: any) {
	const size = useWindowSize();
	const { t } = useTranslation();

	const getConsultationsText = (type: any) =>
		// eslint-disable-next-line react-hooks/rules-of-hooks
		useMemo(() => {
			if (size.width <= 576 || size.width > 992) {
				return (
					<>
						{t(type)}
						<br />
						{t('Consultations')}
					</>
				);
			} else {
				return t(`${type}Consultations`);
			}
		}, [type]);

	const renderIncomeCard = () => (
		<TaCard className="h-full">
			<div className="max-sm:!text-start">
				<h6 className="text-[16px] text-dark font-medium">{t('earned')}</h6>
				<div className="flex justify-center items-center max-sm:!flex-row">
					<p className="text-primary text-[30px] font-[500]">€{specialist?.earned?.eur || 0}</p>
					<span className="h-[34px] w-[1px] bg-[#CFCCD6] mx-[20px]"></span>
					<p className="text-primary text-[30px] font-[500]">${specialist?.earned?.usd || 0}</p>
				</div>
			</div>
		</TaCard>
	);

	return (
		<div className="flex flex-col gap-5 h-full">
			{renderIncomeCard()}
			<PromotionCard
				mdMedia
				number={specialist?.paid_consultation || 0}
				title={getConsultationsText('alreadyPaidForDashboard')}
				numberColor="#1A73E8"
			/>
			<PromotionCard
				mdMedia
				number={specialist?.free_consultation || 0}
				title={getConsultationsText('freeForDashboard')}
				numberColor="#FFAA2B"
			/>
		</div>
	);
}
